import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {H3, Label} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import {useDeal} from "@irati/deals/hooks"

const FlexiRewardPrice: FC = () => {
  const dealInfo = useDeal()
  return (
    <Flex direction="column" alignItems="flex-end">
      {dealInfo.productCount > 1 ? (
        <Label>
          <FormattedMessage id="perks.deal.savings.label.from" />
        </Label>
      ) : (
        <Label>
          <FormattedMessage id="perks.deal.savings.label.price" />
        </Label>
      )}
      <H3>
        <FormattedCurrency isCents={false} value={dealInfo.dealPrice} currency={dealInfo.displayCurrency} />
      </H3>
    </Flex>
  )
}

export default FlexiRewardPrice
